import { LazyTable } from '@vrplatform/table';
import type { api } from '@vrplatform/data';
import { useTrialBalanceTableFilter } from './useTrialBalanceTableFilter';
import { useTrialBalanceTableQuery } from './useTrialBalanceTableQuery';
import { TrialBalanceTableFilter } from './TrialBalanceTableFilter';
import { useTrialBalanceTableColumns } from './useTrialBalanceTableColumns';

export type TrialBalanceJournalEntriesArgs =
  api['/reports/journal-entries']['get']['parameters']['query'];

export const TrialBalanceTable = ({
  onOpenJournalEntries,
}: {
  onOpenJournalEntries?: (filter: TrialBalanceJournalEntriesArgs) => void;
}) => {
  'use memo';

  const { reset: resetFilter, filter: tableFilter } =
    useTrialBalanceTableFilter();
  const data = useTrialBalanceTableQuery();
  const columns = useTrialBalanceTableColumns({ totals: data.data?.totals });

  return (
    <LazyTable
      resetFilter={resetFilter}
      table={{
        emptyRowsFallback: 'No journal entries found',
        columns,
        enableStickyFooter: true,
        onRowClick: onOpenJournalEntries
          ? {
              handler: ({ original: data }) => {
                onOpenJournalEntries({
                  accountIds: data.id,
                  date: tableFilter.date,
                  classifications: tableFilter.classifications?.join(','),
                  party: tableFilter.party ?? undefined,
                  accountType: tableFilter.type ?? undefined,
                  ledger: tableFilter.ledger ?? undefined,
                });
              },
            }
          : undefined,
      }}
      data={{
        rowCount: data.data?.list?.length || 0,
        rows: data.data?.list || [],
        error: data.error?.message,
        loading: data.isLoading,
      }}
      virtualization={{
        enableRowVirtualization: true,
        overscan: 20,
      }}
      // rowMenu={{
      //   menuItems: ({ row }) => {
      //     const id = row.original.id;

      //     if (row.parentId) return null;

      //     return (
      //       <EllipsisMenuItem
      //         customIcon={<CopyIcon size={18} />}
      //         disabled={!id}
      //         onClick={() =>
      //           navigator.clipboard.writeText(id).then(() =>
      //             showSuccessNotification({
      //               message: 'ID copied to clipboard',
      //               icon: null,
      //               autoClose: 1000,
      //             })
      //           )
      //         }
      //       >
      //         Copy account ID
      //       </EllipsisMenuItem>
      //     );
      //   },
      // }}
    >
      <TrialBalanceTableFilter />
    </LazyTable>
  );
};
